import React, { useState } from "react";
import NumberOfPatients from "./NumberOfPatients";
import NomenclatureCode from "./NomenclatureCode";
import {
  setNomenclatureCode,
  setNumberOfPatients,
} from "store/actions/patient.actions";
import { connect } from "react-redux";
import {
  selectNumberOfPatients,
  selectTarifiedToday,
} from "store/reducers/patient.reducer";
import { GlobalState } from "store/configure-store";
import { Nomenclature, nomenclaturesCodes } from "common/models/Nomenclature";
import { selectUser } from "store/reducers/user-context.reducer";
import { User } from "model/user.model";
import Page from "ui/Page";
import { Alert, Icon, Card } from "@cc/react-components";
import { useTranslation } from "react-i18next";
import { PV_NOMENCLATURE_CODE } from "common/matomo/track-page-view.constants";
import { useTrackPageView } from "common/matomo/track-page-view.hook";

const NomenclatureCodeContainer = ({
  numberOfPatients,
  setNumberOfPatients,
  setNomenclatureCode,
  user,
  isTarifiedToday,
}: StateToPropsState & DispatchToPropsState) => {
  const [t] = useTranslation();
  const [show, setShow] = useState(true);

  useTrackPageView(PV_NOMENCLATURE_CODE);

  return (
    <Page.Scrollable>
      <Page.Body>
        {show && isTarifiedToday && (
          <section>
            <Alert variant="primary" onClose={() => setShow(false)} dismissible>
              <p className="mb-0">
                <Icon type="info" className="pr-2" />
                {t("tarificationWarning.tarifiedTodayTitle")}
              </p>
            </Alert>
          </section>
        )}
        <section>
          <Card>
            <Card.Body>
              <NumberOfPatients
                numberOfPatients={numberOfPatients}
                setNumberOfPatients={setNumberOfPatients}
              />
            </Card.Body>
          </Card>
        </section>
        <section>
          <NomenclatureCode
            nomenclatureCodes={nomenclaturesCodes(numberOfPatients, user.nihii)}
            setNomenclatureCode={setNomenclatureCode}
          />
        </section>
      </Page.Body>
    </Page.Scrollable>
  );
};

interface StateToPropsState {
  /**
   * The number of patients that will be selected.
   * This property is provided by the store.
   */
  numberOfPatients: number;
  /** The current user */
  user: User;
  /** If attestation is found for today */
  isTarifiedToday: boolean;
}

interface DispatchToPropsState {
  /**
   * Function that can update the store to save the number of patients.
   * @param numberOfPatients
   */
  setNumberOfPatients(numberOfPatients: number): void;

  setNomenclatureCode(nomenclatureCode: Nomenclature[]): void;
}

const mapStateToProps = (state: GlobalState): StateToPropsState => {
  return {
    numberOfPatients: selectNumberOfPatients(state),
    user: selectUser(state),
    isTarifiedToday: selectTarifiedToday(state),
  };
};

export default connect(mapStateToProps, {
  setNumberOfPatients,
  setNomenclatureCode,
})(NomenclatureCodeContainer);
